import { createEmptyGifState } from "./gifConstants";

const isRemoteUrl = (url) =>
  typeof url === "string" &&
  url.length > 0 &&
  !url.startsWith("blob:") &&
  !url.startsWith("data:");

const revokeBlobUrl = (url) => {
  if (typeof url === "string" && url.startsWith("blob:")) {
    URL.revokeObjectURL(url);
  }
};

const revokeGifImageUrls = (images) => {
  (images || []).forEach((img) => revokeBlobUrl(img?.url));
};

export const hydrateGifCreatorState = (mediaLink = {}) => {
  const storedUrl = isRemoteUrl(mediaLink.url) ? mediaLink.url : "";

  if (storedUrl) {
    revokeGifImageUrls(mediaLink.gifCreator?.images);
    if (!isRemoteUrl(mediaLink.gifCreator?.previewUrl)) {
      revokeBlobUrl(mediaLink.gifCreator?.previewUrl);
    }

    return createEmptyGifState({
      previewUrl: storedUrl,
      isEditing: false,
      isUnsaved: false,
      generatedFile: null,
      images: [],
      mediaProperty: null,
    });
  }

  if (mediaLink.gifCreator) {
    return {
      ...createEmptyGifState(),
      ...mediaLink.gifCreator,
    };
  }

  if (mediaLink.mediaType === "GIF") {
    return createEmptyGifState({
      width: mediaLink.gifWidth || mediaLink.width || undefined,
      height: mediaLink.gifHeight || mediaLink.height || undefined,
      frameDelay: mediaLink.frameDuration || mediaLink.frameDelay || undefined,
      loopCount: mediaLink.loopCount ?? undefined,
      crossfade: !!mediaLink.crossfade,
      crossfadeSteps: mediaLink.crossfadeSteps || undefined,
      background: mediaLink.background || undefined,
      isEditing: true,
      isUnsaved: false,
      generatedFile: null,
      images: [],
    });
  }

  return createEmptyGifState();
};

export const clearSavedGifLocalState = (form, tabKey) => {
  if (!form || !tabKey) return;

  const rows = form.getFieldValue(tabKey);
  if (!Array.isArray(rows)) return;

  let changed = false;
  const nextRows = rows.map((row) => {
    if (row?.mediaLink?.mediaType !== "GIF") return row;

    const gif = row.mediaLink.gifCreator || {};
    revokeGifImageUrls(gif.images);

    const storedUrl = isRemoteUrl(row.mediaLink.url) ? row.mediaLink.url : "";
    const previewUrl = storedUrl || gif.previewUrl || "";

    changed = true;
    return {
      ...row,
      mediaLink: {
        ...row.mediaLink,
        gifCreator: createEmptyGifState({
          previewUrl,
          isEditing: false,
          isUnsaved: false,
          generatedFile: null,
          images: [],
          mediaProperty: null,
        }),
      },
    };
  });

  if (changed) {
    form.setFieldsValue({ [tabKey]: nextRows });
  }
};

export const withGifDefaults = (rows) => {
  if (!Array.isArray(rows)) return rows;
  return rows.map((row) => {
    if (row?.mediaLink?.mediaType === "GIF") {
      return {
        ...row,
        mediaLink: {
          ...row.mediaLink,
          gifCreator: hydrateGifCreatorState(row.mediaLink),
        },
      };
    }
    return row;
  });
};
